import PropTypes from 'prop-types';
import React from 'react';

// context
import { useListingContext } from '@/context/listing';

// hooks
import useFetchListingData from '@/hooks/listing/useFetchListingData';
import useListingLoad from '@/hooks/listing/useListingLoad';
import useListingPagination from '@/hooks/listing/useListingPagination';
import useListingPopstate from '@/hooks/listing/useListingPopstate';

// components
import Facets from '@/kenwood/plpPlus/Facets';
import Heading from '@/kenwood/plpPlus/Heading';
import TotalsAndReset from '@/kenwood/plpPlus/TotalsAndReset';

const FiltersPlus = ({ categoryCode, categoryName, sortData, hasLoadMore }) => {
  // hooks
  const [{ filtersData }] = useListingContext();
  useListingLoad({ categoryCode, sortData, hasLoadMore });
  useFetchListingData(categoryCode);
  useListingPopstate();
  useListingPagination();

  return (
    <div className='--filters-box'>
      <Heading categoryName={categoryName} />
      <Facets facets={filtersData?.facets} />
      <TotalsAndReset
        count={filtersData.count}
        hasFiltersApplied={filtersData.selectedFiltersCount > 0}
      />
    </div>
  );
};

FiltersPlus.propTypes = {
  categoryCode: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  sortData: PropTypes.string.isRequired,
  hasLoadMore: PropTypes.string.isRequired,
};

FiltersPlus.defaultProps = {};

export default FiltersPlus;
